import {chain, get, map} from 'lodash';

import {insertOrMove} from '../../../../../libs/shared/helpers/src/utilities/arrayHelpers';
import {computeNewIndex} from '../../../../components/inboxes/workspaces/dnd/workspaceDragDropHelpers';
import {WorkspaceDropReorderItemArgs} from './types';

function computeReorderedIds<IdType>(
  currentIds: ReadonlyArray<IdType>,
  {droppedItemId, targetItemId, linePosition}: WorkspaceDropReorderItemArgs<IdType>,
): ReadonlyArray<IdType> {
  const droppedItemIndex = currentIds.indexOf(droppedItemId);
  const targetIndex = currentIds.indexOf(targetItemId);
  const newIndex = computeNewIndex(droppedItemIndex, targetIndex, linePosition);

  return insertOrMove(currentIds, newIndex, currentIds[droppedItemIndex]);
}

export function computeReorderedItems<IdType, ItemType>(
  currentItems: ReadonlyArray<ItemType>,
  dropArgs: WorkspaceDropReorderItemArgs<IdType>,
  idPath = 'id',
): ReadonlyArray<ItemType> {
  const currentIds = map(currentItems, idPath);
  const reorderedIds = computeReorderedIds(currentIds, dropArgs);
  return chain(reorderedIds)
    .map((id) => currentItems.find((item) => get(item, idPath) === id))
    .compact()
    .value();
}
